import React from "react";
import { useApp } from "@/context/AppContext";
import { Toranam } from "@/components/Ornaments";
import { ShieldCheck, HeartHandshake, Users2, Landmark } from "lucide-react";

export default function About() {
  const { t, settings } = useApp();
  const founder = settings?.founder_name || "బాచరాజు వరుణ్ కుమార్";
  return (
    <div className="parchment-texture min-h-screen">
      <div className="bg-gradient-to-r from-maroon to-saffron py-12 text-center">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-white">{t("nav_about")}</h1>
      </div>
      <Toranam />
      <div className="max-w-4xl mx-auto px-6 py-12 space-y-8">
        <div className="bg-surface rounded-2xl gold-border temple-shadow p-8 text-center">
          <div className="text-5xl mb-3">🪷</div>
          <h2 className="font-display text-2xl font-bold text-maroon">దేవాలయ బంధం</h2>
          <p className="mt-4 font-telugu text-muted-foreground leading-relaxed">
            దేవాలయ బంధం అనేది పవిత్ర దేవాలయ ట్రస్టులను, భక్తిపరులైన అర్చకులను, పురోహితులను కలిపే ఒక పవిత్ర వేదిక.
            గోత్రం, శాఖ, సూత్రం, ఆగమ సంప్రదాయాల ఆధారంగా సరైన అర్చకులను దేవాలయాలు సులభంగా కనుగొనవచ్చు.
            గ్రామీణ దేవాలయ కమిటీలకు సైతం సులభంగా అర్థమయ్యేలా తెలుగు భాషలో రూపొందించబడింది.
          </p>
          <div className="mt-6 inline-block px-5 py-3 rounded-xl lineage-badge font-telugu">
            వ్యవస్థాపకులు & నిర్వాహకులు: <b>{founder}</b>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          {[[ShieldCheck, "ధృవీకరించబడిన అర్చకులు", "అడ్మిన్ ఆమోదం తర్వాతే ప్రొఫైల్స్ బహిరంగం"],
            [HeartHandshake, "కుటుంబం vs బ్యాచిలర్", "నివాస ప్రాధాన్యత ఆధారంగా సరైన జోడీ"],
            [Users2, "గోత్ర ఆధారిత వడపోత", "వైదిక సంప్రదాయ అనుకూలతను వెంటనే ధృవీకరించండి"],
            [Landmark, "మోసం నిరోధక వ్యవస్థ", "ఒక దేవాలయం — ఒకే నమోదు నియమం"]].map(([Icon, ti, de], i) => (
            <div key={i} className="p-6 rounded-2xl bg-surface gold-border temple-shadow flex gap-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-marigold to-saffron flex items-center justify-center shrink-0"><Icon className="w-6 h-6 text-white" /></div>
              <div><h3 className="font-serifte font-bold text-maroon">{ti}</h3><p className="text-sm text-muted-foreground font-telugu">{de}</p></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
